import React from "react";
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";

import MainView from "Views/MainView";
import DetailsView from "Views/DetailsView";
import Head from "./views/Head";
import history from "Services/history";
import updateStateFromRoute from "Components/SetStateFromRoute";
import { withStateTree } from "State";
import AboutPage from "Views/AboutPage";
import { getChartsForDomainData } from "Components/Charts/componentFilter";
import config from "Config";

import ReactGA from "react-ga";
ReactGA.initialize(config.google_analytics_id);
// see https://analytics.google.com/analytics/web/?authuser=0#/report-home/a86661193w186965404p183841154
history.listen(location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

// error notifications
import Raven from "raven-js";
// TODO: upgrade to sentry@browser
Raven.config(
  "https://2e942a5a22d849a5af48b44fcc0a5e9d@sentry.io/247151"
).install();

const RedirectToFirstAvailableSubcategory = ({ match }) =>
  getChartsForDomainData(
    match.params,
    match.params.geo_aggregation ? "geo_aggregation" : "community"
  ).chain(charts =>
    Object.keys(charts)[0].chain(category =>
      Object.keys(charts[category])[0].chain(subcategory => (
        <Redirect
          to={`${match.url.replace(/\/$/, "")}/${category}/${subcategory}`}
        />
      ))
    )
  );

const TheRouter = ({ tree }) => (
  <div>
    <Head title={config.title} />
    <Router history={history}>
      <div>
        <Route
          path="/*"
          render={({ match }) => {
            let visible = match.url == "/";
            return (
              <div style={{ display: visible ? "block" : "none" }}>
                <MainView visible={visible} tree={tree} />
              </div>
            );
          }}
        />
        <Switch>
          <Route
            exact
            path="/:geo_aggregation(ste|lga|sed)/:geo_aggregation_value/:year"
            render={RedirectToFirstAvailableSubcategory}
          />

          <Route
            exact
            path="/:community(Birthplace|Religion|Language|Ancestry)/:community_value/:year"
            render={RedirectToFirstAvailableSubcategory}
          />

          <Route
            path="/:geo_aggregation(ste|lga|sed)/:geo_aggregation_value/:year/:category/:subcategory"
            name="detail"
            render={({ match }) =>
              updateStateFromRoute(DetailsView).chain(Comp => (
                <Comp tree={tree} match={match} />
              ))
            }
          />

          <Route
            path="/:community(Birthplace|Religion|Language|Ancestry)/:community_value/:year/:category/:subcategory"
            name="detail"
            render={({ match }) =>
              updateStateFromRoute(DetailsView).chain(Comp => (
                <Comp tree={tree} match={match} />
              ))
            }
          />

          <Route
            path="/about"
            name="about"
            render={() => <AboutPage tree={tree} />}
          />
        </Switch>
      </div>
    </Router>
  </div>
);

module.exports = withStateTree(TheRouter);



// WEBPACK FOOTER //
// ./routes.js